import TagManager from 'react-gtm-module';

const tagManagerArgs = {
    gtmId: 'GTM-KXCN9GWM',
};

TagManager.initialize(tagManagerArgs);
